import { projects } from '../../portfolio';
import ProjectContainer from '../ProjectContainer/ProjectContainer';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Projects.css';

const Projects = () => {
  if (!projects.length) return null;

  return (
    <section id='projects' className='section projects'>
      <ScrollReveal>
        <h2 className='section__title'>Projects</h2>
      </ScrollReveal>

      <div className='projects__grid'>
        {projects.map((project, index) => (
          <ScrollReveal key={project.name} delay={index * 80}>
            <ProjectContainer project={project} />
          </ScrollReveal>
        ))}
      </div>
    </section>
  );
};

export default Projects;
